import React, { useState, useRef } from 'react';
import './TagInput.css';

const TagInput = ({ value = [], onChange, placeholder = '태그 입력 후 Enter' }) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  const addTag = (tag) => {
    const trimmed = tag.trim();
    if (!trimmed || value.includes(trimmed)) return;
    onChange([...value, trimmed]);
    setInputValue('');
  };

  const removeTag = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag(inputValue);
    } else if (e.key === 'Backspace' && !inputValue && value.length > 0) {
      removeTag(value.length - 1);
    }
  };

  const handleBlur = () => {
    if (inputValue.trim()) addTag(inputValue);
  };

  return (
    <div className="tag-input-container" onClick={() => inputRef.current?.focus()}>
      {value.map((tag, index) => (
        <span key={index} className="tag-chip">
          {tag}
          <button
            type="button"
            className="tag-remove-btn"
            onClick={(e) => { e.stopPropagation(); removeTag(index); }}
            aria-label={`${tag} 태그 삭제`}
          >
            ✕
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        type="text"
        className="tag-input-field"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={value.length === 0 ? placeholder : ''}
      />
    </div>
  );
};

export default TagInput;
